const educationData = [
  {
    id: 1,
    degree: "Técnico Universitario en Programación",
    institution: "Universidad Tecnológica Nacional",
    year: "2024",
    status: "Graduado"
  },
  {
    id: 2,
    degree: "Técnico Universitario en Desarrollo Web",
    institution: "Universidad Nacional de Entre Ríos",
    year: "2025",
    status: "Graduado",
    duration: "3 años"
  },
  {
    id: 3,
    degree: "Técnico Universitario en Diseño y Desarrollo de Aplicaciones Multiplataforma",
    institution: "Universidad Nacional del Noroeste de la Provincia de Buenos Aires",
    year: "En curso",
    status: "En progreso"
  }
];

export default educationData;